export default __webpack_public_path__ + "images/0x2b6a85cd35d15691357eea61d88cb3f401a92fc3.png";